import { initializeApp } from 'firebase/app'
import { connectFirestoreEmulator, doc, getFirestore } from 'firebase/firestore'

import firebaseConfig, { getFirebaseLocalHost } from './firebaseConfig'
import { installFirestoreConnectionWatchdog } from './firebase-firestore-watchdog'

const app = initializeApp(firebaseConfig)

const firestore = getFirestore(app)

const { firebasePort, firebaseIp } = getFirebaseLocalHost()

if (firebasePort && firebaseIp) {
  connectFirestoreEmulator(
    firestore,
    firebaseIp || 'localhost',
    Number(firebasePort)
  )
}

if (typeof window !== 'undefined') {
  installFirestoreConnectionWatchdog(firestore, {
    healthCheckRef: doc(firestore, 'session-base', 'map'),
  })
}

export default firestore
